import React, { FormEvent, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';

import LoginIllustration from 'src/assets/images/LoginIllustration.svg';
import Logo from 'src/components/Logo';
// import { AUTH_URL } from 'src/configs';

import { handleLogin } from './helpers';
import {
  AdminBadge,
  BrandBar,
  // Field,
  // FieldError,
  // FieldInput,
  // FieldLabel,
  // ForgotLink,
  Illustration,
  IllustrationWrap,
  LoginCard,
  LoginForm,
  // PasswordField,
  // PasswordToggle,
  SignInButton,
  StyledLogInWrap,
  WelcomeTitle,
} from './styled';

// const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const LogIn = () => {
  const { state } = useLocation();
  const signInUrl = handleLogin();
  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // const [passwordVisible, setPasswordVisible] = useState(false);
  const [touched, setTouched] = useState({ email: false, password: false });

  console.log({ touched });

  useEffect(() => {
    if (state?.status === 401) {
      localStorage.removeItem('access');
    }
  }, [state]);

  // const trimmedEmail = email.trim();
  // const emailError =
  //   trimmedEmail.length === 0 ? 'Email is required.' : EMAIL_REGEX.test(trimmedEmail) ? '' : 'Enter a valid email.';
  // const passwordError = password.trim().length === 0 ? 'Password is required.' : '';
  // const hasEmailError = touched.email && Boolean(emailError);
  // const hasPasswordError = touched.password && Boolean(passwordError);
  // const isFormValid = !emailError && !passwordError;

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    setTouched({ email: true, password: true });
    // if (!isFormValid) return;
    window.location.href = signInUrl;
  };

  return (
    <StyledLogInWrap>
      <BrandBar>
        <Logo to={null} />
        <AdminBadge>Admin</AdminBadge>
      </BrandBar>

      <LoginCard>
        <IllustrationWrap>
          <Illustration src={LoginIllustration} alt="" />
        </IllustrationWrap>

        <WelcomeTitle>Welcome to BxLend Admin!</WelcomeTitle>

        <LoginForm onSubmit={handleSubmit}>
          {/* <Field>
            <FieldLabel htmlFor="login-email">Email</FieldLabel>
            <FieldInput
              $invalid={hasEmailError}
              id="login-email"
              type="email"
              name="email"
              autoComplete="username"
              value={email}
              aria-invalid={hasEmailError}
              onBlur={() => setTouched((prev) => ({ ...prev, email: true }))}
              onChange={(e) => {
                setEmail(e.target.value);
                if (!touched.email) return;
                setTouched((prev) => ({ ...prev, email: true }));
              }}
            />
            {hasEmailError && <FieldError>{emailError}</FieldError>}
          </Field>

          <PasswordField>
            <FieldLabel htmlFor="login-password">Password</FieldLabel>
            <FieldInput
              $invalid={hasPasswordError}
              id="login-password"
              type={passwordVisible ? 'text' : 'password'}
              name="password"
              autoComplete="current-password"
              value={password}
              aria-invalid={hasPasswordError}
              onBlur={() => setTouched((prev) => ({ ...prev, password: true }))}
              onChange={(e) => {
                setPassword(e.target.value);
                if (!touched.password) return;
                setTouched((prev) => ({ ...prev, password: true }));
              }}
            />
            <PasswordToggle
              type="button"
              aria-label={passwordVisible ? 'Hide password' : 'Show password'}
              onClick={() => setPasswordVisible((prev) => !prev)}
            >
              {passwordVisible ? <IoEyeOffOutline size={20} /> : <IoEyeOutline size={20} />}
            </PasswordToggle>
            {hasPasswordError && <FieldError>{passwordError}</FieldError>}
          </PasswordField> */}

          <SignInButton type="submit">Log In</SignInButton>
        </LoginForm>

        {/* <ForgotLink href={`${AUTH_URL}/forgot-password`}>Forgot Pass?</ForgotLink> */}
      </LoginCard>
    </StyledLogInWrap>
  );
};

export default LogIn;
